import React from 'react'
import { Link } from 'react-router-dom'

export const Header = () => {
  return (
    <nav className="flex items-center justify-between px-16 py-8 max-w-8xl mx-auto">
        <Link to={'/'} className="text-2xl font-bold tracking-tighter text-[#ef3a5d]">
          <img src='icon.png' style={{ width: 90, borderRadius: 12 }} alt='logo' />
        </Link>
       
      </nav>
  )
}
